import { Directive, Type } from '@angular/core';
import { FormBase, FormType, Validators } from '@sb/library/base';
import { FormFieldBaseComponent } from './form-field-base.component';

@Directive()
export abstract class FormFieldSubformBaseComponent<T, U extends FormBase> extends FormFieldBaseComponent<T, FormType<U>> {
    abstract form: FormType<U>;

    override ngOnInit() {
        super.ngOnInit();

        this.viewControl = this.form;
        this.formControl.ConnectToForm(this.form);

        this.formControl.AddValidators(Validators.subform);
        this.form.isLoading = this.formControl.isLoading;
        this.form.isReadOnly = this.formControl.isReadOnly;
    }

    override ObservePristine() {
    }

    override writeValue(value: T) {
        const wasDisabled = this.form.disabled;

        this.writeFormValue(value);

        if (wasDisabled) {
            this.form.Disable();
        }

        this.form.isDirty = false;
    }

    // NOTE: If using an object to communicate with the subform (e.g., recurrence picker), your writeFormValue should
    // call this method immediately before doing anything else (see form-field-recurrence-picker.component.ts)
    InitializeOnWrite(value: T, formType: Type<T>): NonNullable<T> {
        if (!value) {
            value = new formType();
            setTimeout(() => {
                // Bootstrap the form control value if it has not been set
                if (!this.formControl.value) {
                    this.formControl.setValue(value!, { emitModelToViewChange: false });
                }
            });
        }

        return value!;
    }

    abstract writeFormValue(value: T): void;

    override setDisabledState(state: boolean): void {
        if (state) {
            this.form.Disable();
        } else {
            this.form.Enable();
        }
    }
}
